{
  "languages": {
    "en": "English",
    "es": "Español",
    "it": "Italiano"
  },
  "labels": {
    "language": "Lingua",
    "search": "cerca",
    "share": "Condividi",
    "sharing": "Condivisione",
    "share-confirmation": "Conferma condivisione",
    "datasources": "Sorgenti di dati",
    "custom-operators": "Custom Operator",
    "share-to-collaborate": "Condividi per collaborare",
    "add-users-to-collaborate": "Aggiungi utenti per collaborare",
    "no-shared": "Nessun utente condiviso.",
    "search-user": "Cerca utenti...",
    "view-only-mode": "Scegli chi altro può accedere in modalità di sola visualizzazione",
    "share-limitation": "Condividi con limitazione",
    "no-one": "Nessuno",
    "all-members": "Tutti i membri dell'organizzazione",
    "everyone": "Tutti",
    "owner": "proprietario",
    "editor": "editore",
    "confirm": "Conferma",
    "no-data-available": "Nessun dato disponibile",
    "export": "Esporta",
    "delete": "Elimina",
    "refresh": "Ricarica",
    "cancel": "Annulla",
    "ok": "OK",
    "create-flow": "Crea flusso",
    "select-mashup": "Seleziona mashup",
    "save": "Salva",
    "name": "Nome",
    "open": "Apri",
    "close": "Chiudi",
    "mashup": "Mashup",
    "page-title": "Flussi",
    "file-input": "File",
    "url": "URL",
    "import": "Importa",
    "import-flow": "Importa flusso",
    "depencency": "Dipendenza",
    "type": "Tipo",
    "conflict": "Conflitto",
    "info": "Info",
    "sort-asc": "Ordinamento per creazione ascendente",
    "sort-desc": "Ordinamento per creazione decrescente",
    "duplicate": "Duplica"
  },
  "strings": {
    "delete-flow-question": "Sei sicuro di voler eliminare questo flusso? | Sei sicuro di voler eliminare questi flussi?",
    "unshare-user-tooltip": "Solo il proprietario del flusso può annullare la condivisione con un utente",
    "share-dependencies-intro": "Confermando la condivisione, verranno condivise automaticamente anche le seguenti dipendenze:",
    "confirm-share-dependencies-message": "Vuoi condividerle anche con questo utente?",
    "flow-project-name": "Scrivi il nome per il tuo flusso",
    "flow-mashup-name": "Scegli un mashup per un flusso",
    "duplicate-flow-question": "Sei sicuro di voler duplicare questo flusso?",
    "flow-status": "Lo stato del flusso è {status}",
    "no-flows": "Questa lista è vuota",
    "please-add-flows": "Aggiungi un nuovo Flusso",
    "import-flow-text": "Importa un flusso",
    "import-info": "Puoi caricare un file dal tuo dispositivo locale o puntare a uno remoto tramite il suo URL.",
    "import-suggest-file": "Puoi selezionare un file...",
    "import-suggest-url": "...o inserire un URL",
    "import-file-format": "Importa formato del file",
    "flow-project-url": "Inserisci l'URL della richiesta",
    "select-files": "Seleziona i tuoi file",
    "import-action-new": "Nuova",
    "import-action-skip": "Mantieni",
    "import-action-overwrite": "Sovrascrivi",
    "dialog-info-conflict": "Ci sono conflitti con le seguenti dipendenze del mashup che si sta importando. Per ogni dipendenza, scegliere se aggiungerla come Nuova, Mantenerla così com'è o Sovrascriverla.",
    "dialog-dependencies-no-permission": "nessun permesso",
    "dialog-dependencies-already-released": "già rilasciato",
    "dialog-dependencies-version-dependency": "versione flow",
    "dialog-dependencies-innerprocess-dependency": "flow annidato",
    "dialog-dependencies-endpoint-dependency": "endpoint della fonte di dati",
    "dialog-dependencies-custom-operator-dependency": "operatore personalizzato",
    "dialog-dependencies-flow-dependency": "flow",
    "dialog-dependencies-info-conflict": "Sono presenti conflitti con le seguenti dipendenze del flusso che stai importando. \nPer ciascuna dipendenza, scegli se aggiungerla come Nuova, Mantienila così com'è o Sovrascrivila.",
    "dialog-dependencies-title-conflict": "Conflitto di dipendenze",
    "duplicate-tooltip": "Solo il proprietario può duplicare questo flusso",
    "rename-tooltip": "Solo il proprietario può rinominare questo flusso",
    "export-tooltip": "Solo il proprietario può esportare questo flusso",
    "delete-tooltip": "Solo il proprietario può eliminare questo flusso",
    "delete-multiple-flows-tooltip": "Per eliminare il flusso selezionato devi esserne il proprietario | Alcuni dei flussi selezionati non possono essere eliminati perché non ne sei il proprietario"
  },
  "errors": {
    "flow-name-required": "È richiesto un nome per il flusso",
    "mashup-select-required": "È richiesto il mashup per il tuo progetto di flusso",
    "flow-import-size": "La dimensione dell'importazione deve essere inferiore a 2MB",
    "flow-url-format": "Formato dell'URL non valido"
  }
}
